<template>
  <v-card tile flat>
    <div class="pa-2">
      <base-button @click="addStyle(defaultStyleAdd)" text class="text-none">
        <v-icon>mdi-plus</v-icon>
        {{ $t('preview.actions.add') }}
      </base-button>
    </div>

    <v-tabs
      v-model="currentItem"
      v-if="curent && curent.length > 0"
      class="flex-grow-1"
    >
      <v-tab
        v-for="(item, i) in curent"
        :key="i"
        @click.prevent="selectTab(item)"
        height="30px"
      >
        {{ 'Rule #' + (item + 1) }}
        <v-btn
          icon
          depressed
          text
          @click.prevent="removeStyle($event, item)"
          v-if="curent.length > 1"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="currentItem">
      <v-tab-item v-for="item in curent" :key="item">
        <edit-label-rule
          :item.sync="data[item]"
          :typeLayer.sync="data[item].type"
          :fields="fields"
        ></edit-label-rule>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { DEFAULT_VALUE_LABEL_STYLE, DEFAULT_VALUE_STYLE } from './constant'
import EditLabelRule from './edit-label-rule.vue'
export default {
  components: { EditLabelRule },
  props: {
    value: {},
    layer: {},
    fields: { type: Array },
    defaultStyleAdd: { type: String, default: 'Polygon' },
  },
  data: () => ({
    data: [],
    curent: [],
    more: [],
    currentItem: 0,
    menu: false,
  }),
  watch: {
    value: {
      handler(value) {
        this.data = value || []
        if (!this.data || this.data.length < 1) {
          this.$emit('input', this.data)
          this.addStyle(this.layer.info.type)
        }
        this.setInit()
      },
      immediate: true,
    },
  },
  methods: {
    setInit() {
      let res = [...Array(this.data.length)].map((x, index) => index)
      this.curent = res
    },
    addStyle(type) {
      const item = {
        type,
        comment: { title: '' },
        style: DEFAULT_VALUE_LABEL_STYLE[type] || {},
        rules: [],
      }
      item.field = this.layer.info.datastore_detail?.meta?.field_name
      this.data.push(item)
      this.setInit()
      this.currentItem = this.data.length - 1
    },
    removeStyle(e, index) {
      e.stopPropagation()
      this.data.splice(index, 1)
      this.setInit()
      this.menu = false
    },
    selectTab(index) {},
  },
}
</script>
